export default __webpack_public_path__ + "static/media/beat-the-peak-carousel.cc09f4a7.jpg";